import React from 'react';
import { useTranslation } from 'react-i18next';

import { getRangeValue } from 'component/Layout/Form/RangeSlider/__helper/getRangeValue';
import TimeSliderComponent from 'component/Layout/Form/RangeSlider/TimeSlider';

import { useDepartureFlightTimeAtom } from 'hooks/form/filter';

import { FilterKeys } from '../../types';
import { FlightTimeRange } from '../__config';
import styles from '../Flight.module.scss';
import { FlightTimeProps } from '../index';

const DepartureFlightTime = ({ onSelect }: FlightTimeProps) => {
    const { t } = useTranslation();
    const [departureFlightTime, setDepartureFlightTime] =
        useDepartureFlightTimeAtom();

    return {
        isSelected:
            (!!departureFlightTime?.min &&
                FlightTimeRange.min !== departureFlightTime?.min) ||
            (!!departureFlightTime?.max &&
                FlightTimeRange.max !== departureFlightTime?.max),
        filterValue: t('TRANS-departure-time-outbound'),
        content: (
            <TimeSliderComponent
                key={FilterKeys.DepartureFlightTime}
                label={t('TRANS-departure-time-outbound')}
                onChange={(value) => {
                    const newValue = {
                        min: FlightTimeRange.min !== value[0] ? value[0] : null,
                        max: FlightTimeRange.max !== value[1] ? value[1] : null,
                    };
                    onSelect(getRangeValue(newValue));
                    setDepartureFlightTime(newValue);
                }}
                max={FlightTimeRange.max}
                min={FlightTimeRange.min}
                initialMin={departureFlightTime?.min ?? FlightTimeRange.min}
                initialMax={departureFlightTime?.max ?? FlightTimeRange.max}
                customClassList={{
                    Wrapper: styles.FlightTimeWrapper,
                }}
            />
        ),
    };
};

export default DepartureFlightTime;
